<template>
	<contentBox v-else-if="!loadError" v-bind:loading="loading">	
		<parcel 
			v-if="parcelId" 
			v-bind:handleClose="parcelClose"
			v-bind:handleSelfRoute="parcelSelfRoute"
			v-bind:handleTab="parcelTab"
			v-bind:tab="tab" 
			v-bind:id="parcelId"
			v-bind:noMarker="true" 
			v-bind:noZoomTo="true" 
		/>

		<div class="d-flex flex-column h-100">
			<contentTitle v-if="collection" v-bind:class="$route.params.parcelId? 'd-none': ''" :variant="selected.length === 0? '': 'blue'" label="COLLECTION" close="routeClose">
				<h2 class="text-white font-weight-light pb-2">{{collection.name}}</h2>
			</contentTitle>
			<contentModal v-bind:class="$route.params.parcelId? 'd-none': ''" v-if="mode !== null">
				<collectionEdit v-if="mode === 'edit'" :collection="collection" @close="setMode(null)"/>
				<collectionParcelExport v-if="mode === 'export'" :collection="collection" @close="setMode(null)"/>
				<collectionRemove v-if="mode === 'remove'" :collection="collection" @close="setMode(null)"/>
				<collectionRemoveSelected v-if="mode === 'removeSelected'" :selected="selected" @parcelsRemoved="parcelsRemoved()" @close="setMode(null)"/>
			</contentModal>
			<contentBody v-bind:class="$route.params.parcelId? 'd-none': ''" v-bind:locked="token === null" bg="#f8f9fa">
				

				<contentActions v-if="selected.length === 0">
					<button v-bind:class="{active:mode === 'export'}" v-on:click="setMode('export')" class="btn btn-outline-light btn-sm">
						<i class="material-icons md-18">cloud_download</i> 
						Export
					</button>
					<button v-on:click="poiSet()" class="btn btn-outline-light btn-sm">
						<i class="material-icons md-18">place</i> 
						Center
					</button>
					<button v-bind:class="{active:mode === 'edit'}" v-on:click="setMode('edit')" class="btn btn-outline-light btn-sm">
						<i class="material-icons md-18">edit</i> 
						Edit
					</button>
					<button v-bind:class="{active:mode === 'remove'}" v-on:click="setMode('remove')" class="btn btn-outline-light btn-sm">
						<i class="material-icons md-18">delete</i> 
						Remove
					</button>
				</contentActions>
				<contentActions :variant="'blue'" v-else>
					<span class="text-white mr-2">With {{selected.length}} selected</span>
					<button v-bind:class="{active:mode === 'removeSelected'}" v-on:click="setMode('removeSelected')" class="btn btn-outline-light btn-sm">
						<i class="material-icons md-18">delete</i> 
						Remove
					</button>
					<div v-on:click="clearSelected()" class="text-white content-actions-close">
						<i class="material-icons md-18">close</i>
					</div>
				</contentActions>

				<div v-if="!loading && (!parcels || parcels.length < 1)" class="m-3">
					<h4>No parcels in this collection</h4>
					<p>Add parcels to this collection by viewing a parcel and clicking the save button</p>
				</div>
				<ul v-else-if="!loading" class="list-group list-group-flush">
					<li 
						v-on:click="routeParcel(parcel)"
						v-on:mouseenter="mouseenter($event,parcel)" 
						v-on:mouseleave="mouseleave($event,parcel)" 
						v-for="(parcel, index) in parcels" 
						:key="parcel.id" 
						:class="`list-group-item list-group-item-action justify-content-between d-flex align-items-center cursor-pointer ${isSelected(parcel)? 'parcel-unlocked-selected': ''}`">
						<span>
							{{parcel | address}}
							<small class="text-secondary">{{parcelSub(parcel)}}</small> 
							<div v-if="isSelected(parcel)" v-on:click.stop="deSelectParcel(parcel)" class="collection-list-remove"><i class="material-icons md-18">check_box</i></div>
							<div v-else="" v-on:click.stop="selectParcel(parcel)" class="collection-list-remove"><i class="material-icons md-18">check_box_outline_blank</i></div>
						</span> 
					</li>
				</ul>

			</contentBody>
		</div>
	</contentBox>
</template>

<script>

import collectionEdit from './collection-edit';
import collectionParcelExport from './collection-parcel-export';
import collectionRemove from './collection-remove';
import collectionRemoveSelected from './collection-remove-selected';
import contentBox from '../content';
import contentActions from '../content/content-actions';
import contentBody from '../content/content-body';
import contentModal from '../content/content-modal';
import contentTitle from '../content/content-title';
import parcel from '../parcel/parcel'

export default {
	name: 'collectionParcels',

	components:{
		collectionEdit,
		collectionParcelExport,
		collectionRemove,
		collectionRemoveSelected,
		contentBox,
		contentActions,
		contentBody,
		contentModal,
		contentTitle,
		parcel,
	},

	props:{
		parcelId: Number,
		collectionId: Number,
		tab: String,
	},

	computed: {
		collection: function(){
			return this.$store.state.collections.rec;
		},
		mapLoaded: function(){
			return this.$store.state.map.loaded;
		},
		planCurrent:function(){
			return this.$store.state.plan.current;
		},
		planCurrentIsDayPass:function(){
			if (!this.planCurrent) return false;
			return (!this.planCurrent.plan.recurring && this.planCurrent.plan.interval === 'day')? true: false;
		},
		planCurrentIsStudio:function(){
			if (!this.planCurrent) return false;
			return (this.planCurrent.plan.recurring)? true: false;
		},
		parcels: function(){
			return this.$store.state.collections.parcels;
		},
		parcelFeatures: function(){
			return this.$store.state.collections.parcelFeatures;
		},
		token: function(){
			return this.$store.state.agent.token;
		},
	},
	data: function(){
		return {
			error:null,
			mode: null,
			loading: true,
			loadError: null,
			parcelPoi: null,
			selected:[],
		}
	},
	destroyed: function(){
		this.$store.dispatch('MAP_POI_SET', null);
		this.$store.dispatch('MAP_POI_HOVER_SET', null);
		this.$store.dispatch('MAP_POI_MODE_SET', false);
	},
	methods: {
		checkReady:function(){
			if (this.mapLoaded && !this.loading) return this.poiSet();
		},
		clearSelected:function(){
			this.selected = [];
		},
		get:async function(){
			this.loadError = null;
			try {
				await this.$store.dispatch('COLLECTION_GET', {collectionId:this.collectionId});
				await this.$store.dispatch('COLLECTION_PARCELS_GET', {collectionId:this.collectionId});
				await this.$store.dispatch('COLLECTIONS_PARCEL_FEATURES_GET', {collectionId:this.collectionId});
				this.loading = false;
				this.checkReady();
			} catch(e){
				this.loadError = e;		
			}
		},
		isSelected: function(parcel){
			return this.selected.find(sel => sel.id === parcel.id)? true: false;
		},

		mouseenter: function(e, parcel){

			if (this.parcelPoi && this.parcelPoi[parcel.id]){
				const feature = {
					id:parcel.id,
					source:'poi'
				};
				this.$store.dispatch('MAP_FEATURE_HOVER_SET', [feature]);
			}
			
		},

		mouseleave: function(e, permit){
			this.$store.dispatch('MAP_FEATURE_HOVER_SET',null);
		},
		parcelClose:function(){
			this.$router.push({
				name: 'collection', 
				params:{
					collectionId: this.collectionId
				}
			});
		},
		parcelTab:function(tab){
			this.$router.push({
				name: 'collection-parcel-tab', 
				params:{
					collectionId: this.collectionId,
					parcelId: this.parcelId,
					tab
				}
			});
		},
		parcelSelfRoute:function(){
			this.$router.push({
				name: 'collection-parcel', 
				params:{
					collectionId: this.collectionId,
					parcelId: this.parcelId,
				}
			});
		},
		parcelSub:function(parcel){
			let str = '';
			if (parcel.address){
				if (parcel.address.jurisdiction !== null) str += parcel.address.jurisdiction+', ';
				if (parcel.address.state !== null) str += parcel.address.state+' ';
				if (parcel.address.postal !== null) str += parcel.address.postal;
			}
			return str;
		},
		parcelsRemoved:async function(){
			await this.$store.dispatch('COLLECTIONS_PARCEL_FEATURES_GET', {collectionId:this.collectionId});
			this.poiSet();
			this.clearSelected();
		},
		poiSet:function(){
			let poi = [];
			if (!this.parcelFeatures || this.parcelFeatures.features.length < 1) return;

			this.$store.dispatch('MAP_POI_SET', null);

			this.parcelPoi = {}

			var bounds = new mapboxgl.LngLatBounds();
			
			this.parcelFeatures.features.forEach((feature)=>{
				const feat = {
					...feature,
					properties:{
						...feature.properties,
						route:{
							name: 'collection-parcel', 
							params:{
								collectionId: this.collectionId,
								parcelId: feature.id,
							}
						}
					}
				};
				bounds.extend(feature.geometry.coordinates);
				this.parcelPoi[feature.id] = feat;
				poi.push(feat);
			});

			// todo: figure out why the padding is necessary - bbox looks correct
			this.$store.dispatch('MAP_FIT_BOUNDS', {bounds:{bbox:bounds.toArray()}, padding:350});
			this.$store.dispatch('MAP_POI_SET', poi);	

			if (this.parcelId){
				const feature = {
					id: this.parcelId,
					source:'poi'
				};
				this.$store.dispatch('MAP_FEATURE_ACTIVE_SET', feature);
			}		
		},
		routeClose:function(){
			this.$router.push({
				name: 'home', 
				params:{}
			});
		},
		routeParcel:function(parcel){
			this.$router.push({
				name: 'collection-parcel', 
				params:{
					collectionId: this.collectionId,
					parcelId: parcel.id
				}
			});
		},
		selectParcel:function(parcel){
			if (this.selected.find(sel => sel.id === parcel.id)) return;

			this.selected = [
				...this.selected,
				parcel,
			]
		},
		deSelectParcel:function(parcel){

			const selIndex = this.selected.findIndex(sel => sel.id === parcel.id);
			if (selIndex === -1) return;

			this.selected = [
				...this.selected.slice(0,selIndex),
				...this.selected.slice(selIndex+1)
			]
		},
		setMode:function(mode){
			this.mode = mode
		}
	},
	mounted:function(){
		this.$store.dispatch('MAP_POI_MODE_SET', true);
		this.get();
	},

	watch:{
		mapLoaded:function(){
			this.checkReady();
		},
		parcelFeatures:function(){
			this.checkReady();
		},
		parcelId: function(toParcelId, fromParcelId){
			if (toParcelId === fromParcelId) return

			if (toParcelId){
				const feature = {
					id: toParcelId,
					source:'poi'
				};
				this.$store.dispatch('MAP_FEATURE_ACTIVE_SET', feature);
			} else {
				this.$store.dispatch('MAP_FEATURE_ACTIVE_SET', null);
			}
		},
	}
}

</script>

<style>
	.parcel-unlocked-selected{
		background-color:#BADEFB;
	}
	.parcel-unlocked-selected:hover{
		background-color:#90C9F9;
	}
</style>


// WEBPACK FOOTER //
// src/components/collection/collection-parcels.vue